/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1RequestStatus } from './V1RequestStatus'
import {
    V1RequestStatusFromJSON,
    V1RequestStatusFromJSONTyped,
    V1RequestStatusToJSON,
    V1RequestStatusToJSONTyped
} from './V1RequestStatus'
import type { V1WorkoutRequestData } from './V1WorkoutRequestData'
import {
    V1WorkoutRequestDataFromJSON,
    V1WorkoutRequestDataFromJSONTyped,
    V1WorkoutRequestDataToJSON,
    V1WorkoutRequestDataToJSONTyped
} from './V1WorkoutRequestData'

/**
 *
 * @export
 * @interface V1ProgrammeRequest
 */
export interface V1ProgrammeRequest {
    /**
     *
     */
    id?: string
    /**
     *
     */
    requesterId?: string
    /**
     *
     */
    coachId?: string
    /**
     *
     */
    status?: V1RequestStatus
    /**
     *
     */
    description?: string
    /**
     *
     */
    programmeId?: string
    /**
     *
     */
    transactionId?: string
    /**
     *
     */
    amount?: number
    /**
     *
     */
    autoAccepted?: boolean
    /**
     *
     */
    timeoutAt?: number
    /**
     *
     */
    deliveryDeadlineAt?: number
    /**
     *
     */
    escrowReleaseAt?: number
    /**
     *
     */
    disputeDeadlineAt?: number
    /**
     *
     */
    disputeReason?: string
    /**
     *
     */
    createdAt?: number
    /**
     *
     */
    updatedAt?: number
    /**
     *
     */
    data?: V1WorkoutRequestData
    /**
     *
     */
    paymentUrl?: string
}

/**
 * Check if a given object implements the V1ProgrammeRequest interface.
 */
export function instanceOfV1ProgrammeRequest(
    value: object
): value is V1ProgrammeRequest {
    return true
}

export function V1ProgrammeRequestFromJSON(json: any): V1ProgrammeRequest {
    return V1ProgrammeRequestFromJSONTyped(json, false)
}

export function V1ProgrammeRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1ProgrammeRequest {
    if (json == null) {
        return json
    }
    return {
        id: json['id'] == null ? undefined : json['id'],
        requesterId:
            json['requesterId'] == null ? undefined : json['requesterId'],
        coachId: json['coachId'] == null ? undefined : json['coachId'],
        status:
            json['status'] == null
                ? undefined
                : V1RequestStatusFromJSON(json['status']),
        description:
            json['description'] == null ? undefined : json['description'],
        programmeId:
            json['programmeId'] == null ? undefined : json['programmeId'],
        transactionId:
            json['transactionId'] == null ? undefined : json['transactionId'],
        amount: json['amount'] == null ? undefined : json['amount'],
        autoAccepted:
            json['autoAccepted'] == null ? undefined : json['autoAccepted'],
        timeoutAt: json['timeoutAt'] == null ? undefined : json['timeoutAt'],
        deliveryDeadlineAt:
            json['deliveryDeadlineAt'] == null
                ? undefined
                : json['deliveryDeadlineAt'],
        escrowReleaseAt:
            json['escrowReleaseAt'] == null
                ? undefined
                : json['escrowReleaseAt'],
        disputeDeadlineAt:
            json['disputeDeadlineAt'] == null
                ? undefined
                : json['disputeDeadlineAt'],
        disputeReason:
            json['disputeReason'] == null ? undefined : json['disputeReason'],
        createdAt: json['createdAt'] == null ? undefined : json['createdAt'],
        updatedAt: json['updatedAt'] == null ? undefined : json['updatedAt'],
        data:
            json['data'] == null
                ? undefined
                : V1WorkoutRequestDataFromJSON(json['data']),
        paymentUrl: json['paymentUrl'] == null ? undefined : json['paymentUrl']
    }
}

export function V1ProgrammeRequestToJSON(json: any): V1ProgrammeRequest {
    return V1ProgrammeRequestToJSONTyped(json, false)
}

export function V1ProgrammeRequestToJSONTyped(
    value?: V1ProgrammeRequest | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        id: value['id'],
        requesterId: value['requesterId'],
        coachId: value['coachId'],
        status: V1RequestStatusToJSON(value['status']),
        description: value['description'],
        programmeId: value['programmeId'],
        transactionId: value['transactionId'],
        amount: value['amount'],
        autoAccepted: value['autoAccepted'],
        timeoutAt: value['timeoutAt'],
        deliveryDeadlineAt: value['deliveryDeadlineAt'],
        escrowReleaseAt: value['escrowReleaseAt'],
        disputeDeadlineAt: value['disputeDeadlineAt'],
        disputeReason: value['disputeReason'],
        createdAt: value['createdAt'],
        updatedAt: value['updatedAt'],
        data: V1WorkoutRequestDataToJSON(value['data']),
        paymentUrl: value['paymentUrl']
    }
}
